import { render, staticRenderFns } from "./OrderAlphabeticalDescending.vue?vue&type=template&id=619dcc49&scoped=true"
import script from "./OrderAlphabeticalDescending.vue?vue&type=script&lang=js"
export * from "./OrderAlphabeticalDescending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619dcc49",
  null
  
)

export default component.exports